import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingClassSelectComponent } from './building-class-select/building-class-select.component';
import { ActionSelectComponent } from './action-select/action-select.component';
import { BuildingSelectComponent } from './building-select/building-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeadlineSelectComponent } from './deadline-select/deadline-select.component';
import { NebularModule } from '../nebular/nebular.module';
import { StatusSelectComponent } from './status-select/status-select.component';
import { UserSelectComponent } from './user-select/user-select.component';
import { TenantSelectComponent } from '@shared/form-controls/tenant-select/tenant-select.component';
import { BuildingTypeSelectComponent } from './building-type-select/building-type-select.component';
import { CheckpointGroupSelectComponent } from './checkpoint-group-select/checkpoint-group-select.component';
import { CheckpointSelectComponent } from './checkpoint-select/checkpoint-select.component';
import { CorporateGroupSelectComponent } from './corporate-group-select/corporate-group-select.component';
import { CatalogSourceTenantSelectComponent } from './catalog-source-tenant-select/catalog-source-tenant-select.component';
import { AttachmentUploadModule } from './attachment-upload/attachment-upload.module';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { InspectionTypeSelectComponent } from '@shared/form-controls/inspection-type-select/inspection-type-select.component';
import { NormTypeSelectComponent } from './norm-type-select/norm-type-select.component';
import { AutomaticAddressComponent } from './automatic-address/automatic-address.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { AssessmentPresetSelectComponent } from './assessment-preset-select/assessment-preset-select.component';
import { BuildingAtticSelectComponent } from './building-attic-select/building-attic-select.component';
import { PipesModule } from '../pipes/pipes.module';
import { ThresholdSliderComponent } from './threshold-slider/threshold-slider.component';
import { ConditionSelectComponent } from '@shared/form-controls/condition-select/condition-select.component';
import { TenantMultiSelectComponent, } from '@shared/form-controls/tenant-multi-select/tenant-multi-select.component';
import { RepairTaskStatusSelectComponent } from './repair-task-status-select/repair-task-status-select.component';
import { CustomFieldsSelectComponent } from './custom-fields-select/custom-fields-select.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import {
  CustomFieldCollectionsSelectComponent,
} from './custom-field-collections-select/custom-field-collections-select.component';
import { NgxSliderModule } from 'ngx-slider-v2';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { TagSelectComponent } from './tag-select/tag-select.component';
import { TagMultiSelectComponent } from '@shared/form-controls/tag-multi-select/tag-multi-select.component';
import { TgaTypeSelectComponent } from '@shared/form-controls/tga-type-select/tga-type-select.component';
import {
  BuildingEquipmentMultiSelectComponent,
} from './building-equipment-multi-select/building-equipment-multi-select.component';
import { ComponentsModule } from '@shared/components/components.module';
import { BuildingEquipmentsEditorComponent } from './building-equipments-editor/building-equipments-editor.component';
import { PinInputComponent } from './pin-input/pin-input.component';
import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';
import { EditorComponent } from '@tinymce/tinymce-angular';
import {
  BuildingSectionMultiSelectComponent
} from './building-section-multi-select/building-section-multi-select.component';
import { UserMultiSelectComponent } from '@shared/form-controls/user-multi-select/user-multi-select.component';
import { CommentsComponent } from '@shared/components/comments/comments.component';
import {
  NotificationVariantSelectComponent
} from './notification-variant-select/notification-variant-select.component';
import { NotificationTypeSelectComponent } from './notification-type-select/notification-type-select.component';
import { EmailTypeSelectComponent } from './email-type-select/email-type-select.component';
import { BuildingMultiSelectComponent } from './building-multi-select/building-multi-select.component';
import { TenantRoleSelectComponent } from './tenant-role-select/tenant-role-select.component';
import {
  TeamBuildingPickListComponent
} from '@shared/form-controls/team-building-pick-list/team-building-pick-list.component';
import { UserPickListComponent } from '@shared/form-controls/user-pick-list/user-pick-list.component';
import { TeamPickListComponent } from '@shared/form-controls/team-pick-list/team-pick-list.component';
import { TeamSelectComponent } from '@shared/form-controls/team-select/team-select.component';
import { RegionSelectComponent } from '@shared/form-controls/region-select/region-select.component';
import { TenantPickListComponent } from '@shared/form-controls/tenant-pick-list/tenant-pick-list.component';
import {
  AttachmentFolderTreeComponent
} from '@shared/form-controls/attachment-folder-tree/attachment-folder-tree.component';
import { FixedTenantSelectComponent } from '@shared/form-controls/fixed-tenant-select/fixed-tenant-select.component';
import {
  BuildingOwnerSelectComponent
} from '@shared/form-controls/building-owner-select/building-owner-select.component';
import { GenericPickListComponent } from '@shared/form-controls/generic-pick-list/generic-pick-list.component';
import {
  InsuranceCompanySelectComponent
} from '@shared/form-controls/insurance-company-select/insurance-company-select.component';
import { SensorUnitSelectComponent } from '@shared/form-controls/sensor-unit-select/sensor-unit-select.component';
import {
  DateTimeRangePickerComponent
} from '@shared/form-controls/date-time-range-picker/date-time-range-picker.component';
import {
  AggregationIntervalSelectComponent
} from '@shared/form-controls/aggregation-interval-select/aggregation-interval-select.component';
import { LabelSelectComponent } from '@shared/form-controls/label-select/label-select.component';
import { DimensionSelectComponent } from '@shared/form-controls/dimension-select/dimension-select.component';
import { LabelCategorySelectComponent } from '@shared/form-controls/label-category-select/label-category-select.component';
import {
  SensorUnitLabelSelectComponent
} from '@shared/form-controls/sensor-unit-label-select/sensor-unit-label-select.component';
import {
  ControlSystemSelectComponent
} from '@shared/form-controls/control-system-select/control-system-select.component';
import {
  SensorMetricKindSelectComponent
} from '@shared/form-controls/sensor-metric-kind-select/sensor-metric-kind-select.component';
import {
  SensorPurposeSelectComponent
} from '@shared/form-controls/sensor-purpose-select/sensor-purpose-select.component';
import {
  SensorIntegrationTypeSelectComponent
} from '@shared/form-controls/sensor-integration-type-select/sensor-integration-type-select.component';
import {
  FacilityElementMultiSelectComponent
} from '@shared/form-controls/facility-element-multi-select/facility-element-multi-select.component';
import {
  FacilityElementSelectComponent
} from '@shared/form-controls/facility-element-select/facility-element-select.component';
import {
  BuildingSectionSelectFormControlComponent
} from '@shared/form-controls/building-section-select-form-control/building-section-select-form-control.component';
import {
  BuildingEquipmentSelectComponent
} from '@shared/form-controls/building-equipment-select/building-equipment-select.component';
import {
  FacilityElementContractorPickListComponent
} from '@shared/form-controls/facility-element-contractor-pick-list/facility-element-contractor-pick-list.component';
import {
  InspectionContractorSelectComponent
} from '@shared/form-controls/inspection-contractor-select/inspection-contractor-select.component';
import { ColorPresetPickerComponent } from '@shared/form-controls/color-preset-picker/color-preset-picker.component';
import { DeprecatedSelectComponent } from '@shared/form-controls/deprecated-select/deprecated-select.component';
import {
  ApplicationStatusSelectComponent
} from '@shared/form-controls/application-status-select/application-status-select.component';
import {
  EquipmentFieldFilterComponent
} from '@shared/form-controls/equipment-field-filter/equipment-field-filter.component';
import {
  SensorInstallationSelectComponent
} from '@shared/form-controls/sensor-installation-select/sensor-installation-select.component';
import { AreaInputComponent } from '@shared/form-controls/area-input/area-input.component';
import {
  CustomFieldCompositionControlComponent
} from './custom-field-composition-control/custom-field-composition-control.component';
import {
  CustomFieldLayoutEditorComponent
} from './custom-field-layout-editor/custom-field-layout-editor.component';

@NgModule({
  declarations: [
    BuildingClassSelectComponent,
    ActionSelectComponent,
    BuildingSelectComponent,
    DeadlineSelectComponent,
    StatusSelectComponent,
    UserSelectComponent,
    TenantSelectComponent,
    BuildingTypeSelectComponent,
    CheckpointGroupSelectComponent,
    CheckpointSelectComponent,
    CorporateGroupSelectComponent,
    CatalogSourceTenantSelectComponent,
    DateRangePickerComponent,
    NormTypeSelectComponent,
    InspectionTypeSelectComponent,
    DatePickerComponent,
    AutomaticAddressComponent,
    TimePickerComponent,
    AssessmentPresetSelectComponent,
    BuildingAtticSelectComponent,
    ThresholdSliderComponent,
    ConditionSelectComponent,
    TagMultiSelectComponent,
    TagSelectComponent,
    TenantMultiSelectComponent,
    RepairTaskStatusSelectComponent,
    CustomFieldsSelectComponent,
    CustomFieldCollectionsSelectComponent,
    PinInputComponent,
    TgaTypeSelectComponent,
    BuildingEquipmentMultiSelectComponent,
    BuildingEquipmentsEditorComponent,
    RichTextEditorComponent,
    BuildingSectionMultiSelectComponent,
    UserMultiSelectComponent,
    CommentsComponent,
    NotificationVariantSelectComponent,
    NotificationTypeSelectComponent,
    EmailTypeSelectComponent,
    BuildingMultiSelectComponent,
    TenantRoleSelectComponent,
    TeamBuildingPickListComponent,
    UserPickListComponent,
    TeamPickListComponent,
    TeamSelectComponent,
    RegionSelectComponent,
    TenantPickListComponent,
    AttachmentFolderTreeComponent,
    FixedTenantSelectComponent,
    BuildingOwnerSelectComponent,
    GenericPickListComponent,
    InsuranceCompanySelectComponent,
    GenericPickListComponent,
    SensorUnitSelectComponent,
    DateTimeRangePickerComponent,
    AggregationIntervalSelectComponent,
    LabelSelectComponent,
    DimensionSelectComponent,
    LabelCategorySelectComponent,
    SensorUnitLabelSelectComponent,
    ControlSystemSelectComponent,
    SensorMetricKindSelectComponent,
    SensorPurposeSelectComponent,
    SensorIntegrationTypeSelectComponent,
    GenericPickListComponent,
    FacilityElementMultiSelectComponent,
    FacilityElementSelectComponent,
    BuildingSectionSelectFormControlComponent,
    BuildingEquipmentSelectComponent,
    FacilityElementContractorPickListComponent,
    InspectionContractorSelectComponent,
    ColorPresetPickerComponent,
    DeprecatedSelectComponent,
    ApplicationStatusSelectComponent,
    EquipmentFieldFilterComponent,
    SensorInstallationSelectComponent,
    AreaInputComponent,
    CustomFieldCompositionControlComponent,
    CustomFieldLayoutEditorComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    NebularModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    AttachmentUploadModule,
    NgxSliderModule,
    CustomFormModule,
    ComponentsModule,
    EditorComponent,
  ],
  exports: [
    BuildingClassSelectComponent,
    ActionSelectComponent,
    BuildingSelectComponent,
    DeadlineSelectComponent,
    StatusSelectComponent,
    TenantSelectComponent,
    UserSelectComponent,
    BuildingTypeSelectComponent,
    CheckpointGroupSelectComponent,
    CheckpointSelectComponent,
    CorporateGroupSelectComponent,
    CatalogSourceTenantSelectComponent,
    AttachmentUploadModule,
    DateRangePickerComponent,
    NormTypeSelectComponent,
    InspectionTypeSelectComponent,
    DatePickerComponent,
    AutomaticAddressComponent,
    TimePickerComponent,
    AssessmentPresetSelectComponent,
    BuildingAtticSelectComponent,
    ThresholdSliderComponent,
    ConditionSelectComponent,
    TagMultiSelectComponent,
    TenantMultiSelectComponent,
    RepairTaskStatusSelectComponent,
    CustomFieldsSelectComponent,
    CustomFieldCollectionsSelectComponent,
    TgaTypeSelectComponent,
    BuildingEquipmentMultiSelectComponent,
    BuildingEquipmentsEditorComponent,
    PinInputComponent,
    RichTextEditorComponent,
    TagSelectComponent,
    BuildingSectionMultiSelectComponent,
    UserMultiSelectComponent,
    CommentsComponent,
    NotificationVariantSelectComponent,
    NotificationTypeSelectComponent,
    EmailTypeSelectComponent,
    BuildingMultiSelectComponent,
    TenantRoleSelectComponent,
    TeamBuildingPickListComponent,
    UserPickListComponent,
    TeamPickListComponent,
    TeamSelectComponent,
    RegionSelectComponent,
    TenantPickListComponent,
    AttachmentFolderTreeComponent,
    FixedTenantSelectComponent,
    BuildingOwnerSelectComponent,
    GenericPickListComponent,
    InsuranceCompanySelectComponent,
    GenericPickListComponent,
    SensorUnitSelectComponent,
    DateTimeRangePickerComponent,
    AggregationIntervalSelectComponent,
    LabelSelectComponent,
    DimensionSelectComponent,
    LabelCategorySelectComponent,
    SensorUnitLabelSelectComponent,
    ControlSystemSelectComponent,
    SensorMetricKindSelectComponent,
    SensorPurposeSelectComponent,
    SensorIntegrationTypeSelectComponent,
    GenericPickListComponent,
    FacilityElementMultiSelectComponent,
    FacilityElementSelectComponent,
    BuildingSectionSelectFormControlComponent,
    BuildingEquipmentSelectComponent,
    FacilityElementContractorPickListComponent,
    InspectionContractorSelectComponent,
    ColorPresetPickerComponent,
    DeprecatedSelectComponent,
    ApplicationStatusSelectComponent,
    EquipmentFieldFilterComponent,
    DeprecatedSelectComponent,
    SensorInstallationSelectComponent,
    AreaInputComponent,
    CustomFieldCompositionControlComponent,
    CustomFieldLayoutEditorComponent,
  ],
})
export class FormControlsModule {
}
